module.exports = __webpack_public_path__ + "img/wait_clean_room.57ae565e.svg";